// The sentence length for Japanese is measured in characters rather than words.
export default {
	recommendedLength: 40,
};
